"use client";
import ProductCard from "@/app/views/popular/components/ProductCard";
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle
} from "@/components/ui/card";
import CustomBreadcrumbs from "@/custom/CustomBreadcrumbs";
import CustomPagination from "@/custom/CustomPagination";
import { LibraryBig } from "lucide-react";
import { useSearchParams } from "next/navigation";
import Filters from "./Filters";

const Products = ({ products, total, count, range, brands }) => {
  const searchParams = useSearchParams();
  const search = searchParams.get("search");

  return (
    <div className="container mx-auto my-10">
      <div className="space-y-10">
        <CustomBreadcrumbs text={search} />
        <div className="flex flex-col lg:flex-row items-start gap-4">
          <Filters brands={brands} />
          <div className="flex flex-wrap gap-4">
            {products?.length === 0 ? (
              <Card>
                <CardHeader>
                  <CardTitle className="text-xl font-medium">
                    <LibraryBig strokeWidth={1} size={45} />
                    <p>No Products Found</p>
                  </CardTitle>
                  <CardDescription className="text-custom-black ">
                    We couldn&apos;t find any products matching your criteria.
                    Please adjust your search or reset filters. For
                    assistance, contact our support. Thank you.
                  </CardDescription>
                </CardHeader>
              </Card>
            ) : (
              <div className="grid grid-cols-2 md:grid-cols-3  lg:grid-cols-4 gap-3 sm:gap-4">
                {products?.map((book, i) => (
                  <div className="w-full  relative overflow-hidden" key={i}>
                    <ProductCard product={book} />
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        <CustomPagination total={total} count={count} />
      </div>
    </div>
  );
};

export default Products;
